<ng-container *transloco="let t">
  <mat-toolbar>
    <!-- MENU -->
    <div class="toolbar-box">
      <a [routerLink]="['/']" class="logo">
        <img
          [src]="
            (countryRepo.activeCountry$ | async)?.country_code !==
            CountryCode.CZECH
              ? 'assets/images/logo/stockout-logo.png'
              : 'assets/images/logo/sandoz-logo-czech.png'
          "
          alt="Logo"
        />
      </a>
    </div>

    <div class="toolbar-box spacer mobile-only"></div>

    @if (sessionRepo.isLoggedIn$ | async) {
      <div class="toolbar-box spacer main-nav-spacer desktop-only">
        <div class="main-nav-links">
          <a
            matRipple
            class="clean-link"
            [routerLink]="[
              countryRepo.countryParam$ | async,
              RoutePaths.ShortageOverview,
            ]"
            routerLinkActive="active-link"
            data-ga-id="shortage-overview-link"
          >
            {{
              (isSwitzerland$ | async)
                ? t('HEADER.SHORTAGE_ALTERNATIVES_AND_OVERVIEW_CH_ONLY')
                : t('HEADER.SHORTAGE_ALTERNATIVES_AND_OVERVIEW')
            }}
          </a>
          <a
            matRipple
            class="clean-link tutorial-step-faq"
            [routerLink]="[countryRepo.countryParam$ | async, RoutePaths.FAQ]"
            routerLinkActive="active-link"
            data-ga-id="faq-link"
          >
            {{ t('FAQ.TITLE') }}
          </a>
        </div>
      </div>

      <div class="toolbar-box desktop-only">
        <button mat-button (click)="doTutorial()">
          <span>Tutorial</span>
        </button>
      </div>
    } @else {
      <div class="toolbar-box spacer"></div>
    }

    <div class="toolbar-box tutorial-step-contrast">
      <button mat-icon-button (click)="toggleTheme()">
        <mat-icon>settings_brightness</mat-icon>
      </button>
    </div>

    <div class="toolbar-box tutorial-step-notifications">
      @if (sessionRepo.isLoggedIn$ | async) {
        <button
          mat-icon-button
          color="primary"
          class="notification-button filled-in-icon-button primary"
          [matBadge]="notificationRepo.numberOfUnreadNotifications$ | async"
          [matBadgeHidden]="
            !(notificationRepo.numberOfUnreadNotifications$ | async)
          "
          (click)="openNotificationsDialog()"
        >
          <mat-icon>notifications</mat-icon>
        </button>
      } @else {
        <a
          mat-icon-button
          color="primary"
          class="notification-button filled-in-icon-button primary"
          [routerLink]="['/', RoutePaths.Login]"
        >
          <mat-icon>notifications</mat-icon>
        </a>
      }
    </div>

    @if (languageRepo.appLanguage$ | async; as selectedLanguage) {
      <div
        class="toolbar-box language tutorial-step-languageSelect desktop-only"
        id="step1"
      >
        <div
          matRipple
          class="center-align pointer"
          tabindex="0"
          data-ga-id="language-select"
          (click)="openLanguageSelectDialog()"
        >
          <img
            [src]="'assets/images/flags/' + selectedLanguage.flag + '.png'"
            style="margin-right: 4px"
          />
          <span id="step1">{{ selectedLanguage.title }}</span>
        </div>
      </div>
    }

    <div class="toolbar-box desktop-only">
      @if (!(sessionRepo.isLoggedIn$ | async)) {
        <a [routerLink]="['/', RoutePaths.Login]">
          {{ t('GENERAL.LOGIN') }}
        </a>
      } @else {
        <button mat-button (click)="logout()">
          {{ t('GENERAL.LOGOUT') }}
        </button>
      }
    </div>

    <div class="toolbar-box mobile-only">
      <button
        mat-icon-button
        (click)="$isMobileMenuOpen.set(!$isMobileMenuOpen())"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <!-- MENU -->

    <!-- MOBILE MENU -->
    @if ($isMobileMenuOpen()) {
      <div class="mobile-menu">
        @if (languageRepo.appLanguage$ | async; as selectedLanguage) {
          <div
            matRipple
            class="mobile-menu-item center-align pointer"
            (click)="openLanguageSelectDialog()"
          >
            <img
              [src]="'assets/images/flags/' + selectedLanguage.flag + '.png'"
              style="margin-right: 4px"
            />
            <span>{{ selectedLanguage.title }}</span>
          </div>
        }
        <a
          matRipple
          class="mobile-menu-item clean-link center-align"
          [routerLink]="[
            countryRepo.countryParam$ | async,
            RoutePaths.ShortageOverview,
          ]"
          (click)="closeMobileMenu()"
        >
          {{ t('HEADER.SHORTAGE_ALTERNATIVES_AND_OVERVIEW') }}
        </a>
        <a
          matRipple
          class="mobile-menu-item clean-link center-align"
          [routerLink]="[countryRepo.countryParam$ | async, RoutePaths.FAQ]"
          (click)="closeMobileMenu()"
        >
          {{ t('FAQ.TITLE') }}
        </a>

        @if (!(sessionRepo.isLoggedIn$ | async)) {
          <a
            matRipple
            class="mobile-menu-item center-align pointer clean-link"
            [routerLink]="['/login']"
            (click)="closeMobileMenu()"
          >
            {{ t('GENERAL.LOGIN') }}
          </a>
        } @else {
          <div
            matRipple
            class="mobile-menu-item center-align pointer"
            (click)="closeMobileMenu(); logout()"
          >
            {{ t('GENERAL.LOGOUT') }}
          </div>
        }
      </div>
    }
    <!-- MOBILE MENU -->
  </mat-toolbar>
</ng-container>
